// Scribe caps a list page at 200; one page covers every patient we expect.
export const CONSULTATIONS_LIST_LIMIT = 200;

export enum CONSULTATION_TYPE {
  Dental = 'dental',
  Pediatric = 'pediatric',
  Medical = 'medical',
  CoordinatorNewPatient = 'coordinator_new_patient',
  CoordinatorFollowUp = 'coordinator_follow_up',
  Soap = 'soap',
}

export enum TRANSCRIPTOR_LANGUAGE {
  English = 'en',
  German = 'de',
  Spanish = 'es',
  French = 'fr',
  Hebrew = 'he',
  Hungarian = 'hu',
  Italian = 'it',
  Georgian = 'ka',
  Kazakh = 'kk',
  Polish = 'pl',
  Portuguese = 'pt',
  Romanian = 'ro',
  Russian = 'ru',
  Ukrainian = 'uk',
}

export const SUPPORTED_CONTENT_LANGUAGES = [
  TRANSCRIPTOR_LANGUAGE.English,
  TRANSCRIPTOR_LANGUAGE.Russian,
  TRANSCRIPTOR_LANGUAGE.German,
  TRANSCRIPTOR_LANGUAGE.Spanish,
  TRANSCRIPTOR_LANGUAGE.Portuguese,
  TRANSCRIPTOR_LANGUAGE.Hungarian,
];

export const API_STATUS_MAP = {
  unknown: 'unknown',
  in_progress: 'in_progress',
  succeeded: 'succeeded',
  failed: 'failed',
} as const;

export const PROCESSING_PROGRESS_MAP = {
  unknown: 0,
  in_progress: 50,
  succeeded: 100,
  failed: 0,
  default: 0,
} as const;

export const OBJECT_ID_LENGTH = 24;

// Wire contract with scribe: the skip reason scribe records on every document
// (and mirrors on the encounter) when a recording has no detectable speech.
// Keep in sync with model.NoSpeechDetectedError in services/scribe.
export const NO_SPEECH_DETECTED_ERROR = 'no speech detected in recording';

export const NANOSECONDS_PER_SECOND = 1_000_000_000;

export const RECORDING_EVENT_PREFIX = 'transcriptor_recording_';

export const AUDIO_CONFIG = {
  SAMPLE_RATE: 16000,
  CHUNK_DURATION_MS: 30000, // 30 seconds
  MAX_FILE_SIZE_MB: 100,
  SUPPORTED_FORMATS: [
    'audio/webm',
    'audio/mp4',
    'audio/wav',
    'audio/mpeg',
    'audio/ogg',
    'video/webm',
  ],
  SUPPORTED_MIME_TYPES: [
    'audio/webm',
    'audio/mp4',
    'audio/wav',
    'audio/mpeg',
    'audio/ogg',
    'video/webm',
    'audio/m4a',
    'audio/x-m4a',
  ],
  DEFAULT_MIME_TYPE: 'audio/webm',
} as const;
